import DependencyInjector from "./DependencyInjector";

/**
 *  Select2 Init (jQuery)
 *  params: - component (to load select2 module)
 *          - otherOptions
 *
 */
export const Select2Init = (otherOptions = {}) => {
  new DependencyInjector().loadSelect2AndExecute(
    () => {
      function formatOption(option) {
        // no icon
        if ($(option.element).data("icon") === undefined) {
          return $(`<p ${$(option.element).hasClass("unavailable") ? 'class="unavailable"' : ""}>
              <span>${option.text}</span>
            </p>`);
        }
        return $(`<p ${$(option.element).hasClass("unavailable") ? 'class="unavailable"' : ""}>
            <span>${option.text}</span>
            <i class="${$(option.element).data("icon")} --m"></i>
          </p>`);
      }

      let options = {
        templateResult: formatOption,
      };

      // get custom options
      const $select = $("select.custom-select__select");
      const isMobile = window.innerWidth < 768;

      options = {
        ...options,
        ...otherOptions,
        ...(isMobile ? { minimumResultsForSearch: Infinity } : {}),
      };

      // init
      const $customSelect = $select.select2(options);

      $select.on('select2:open', (event) => {
        document.querySelectorAll('.select2-search__field').forEach((input) => {
          input.setAttribute('inputmode', 'none');
          input.blur();
        });

        //rotate arrow
        $(event.target).next().find(".select2-selection__arrow").addClass("open");
      });

      $select.on('select2:close', (event) => {
        //rotate arrow
        $(event.target).next().find(".select2-selection__arrow").removeClass("open");
      });

      $select.on('select2:select', (event) => {
        // ADD SELECTED CLASS FOR FLOATING LABEL
        $(event.target).siblings('label').first().addClass('selected');
        //rotate arrow
        $(event.target).next().find(".select2-selection__arrow").removeClass("open");
      });

      $(document).on('keydown', '.select2.select2-container', function (event) {
        const isOriginalEvent = event.originalEvent // don't re-open on closing focus event
        const isSingleSelect = $(this).find(".select2-selection--single").length > 0 // multi-select will pass focus to input

        if (isOriginalEvent && isSingleSelect && (event.keyCode == 38 || event.keyCode == 40)) {
          $(this).siblings('select:enabled').select2('open');
        }
      });

      $select.on("change", event => {
        $(event.target).siblings('label').first().addClass('selected');
      });
    },
    (error) => {
      console.error("failed to load select2", error.stack);
    },
  );
};
